const initialState = () => ({
  keep_filters: false,

  filters: {
    no_interaction: false,
    idle_only: null,

    start_timestamp: null,
    end_timestamp: null,
    user: [],
    user_id: [],
    product_id: [],
    product: [],
    stage: [],
    city_name: [],
    tags: [],
    forms: [],
    last_workspace_id: [],

    source_type: null,
    campaign_id: [],
    marketing_campaign_id: [],
    media_id: [],
    closed_type: [],
    timestamp_attribute: "updated_at",
    probability: null,
    state_code: null,

    has_call: null,
    has_call_min_duration: null,
    max_call_attempts: null,
    call_start_timestamp: null,
    call_end_timestamp: null,

    has_user: null,
    has_city_name: null,
    has_state_code: null,
    has_campaign: null,
    has_product: null,
    has_contract_id: null,

    is_blacklisted: null,

    has_generator: null,

    opportunity_type_id: null,
    media_type: null,

    has_batch_message: null,
    batch_message_id: [],
    no_replied_batch_message: undefined,
  },

  batch_messages: [],

  sortType: [],
  sortDirection: [],

  redirectFromUsers: null,

  date_types: [
    { id: "created_at", title: "Data de criação" },
    { id: "updated_at", title: "Data de atualização" },
    { id: "closed_at", title: "Data de conclusão" },
    { id: "voip", title: "Data do Voip" },
  ],

  media_types: [
    { id: "Offline", title: "Offline" },
    { id: "Google", title: "Google" },
    { id: "SocialMedia", title: "Social Media" },
  ],

  call_options: [
    { id: false, title: "Sem ligação realizada" },
    { id: true, title: "Com ligação realizada" },
  ],

  answering_options: [
    { id: true, title: "Todas as ligações atendidas" },
    {
      id: false,
      title: "Não atendidas (Recusado/caixa postal/menos 15s)",
    },
  ],

  getDurationOptions: [
    { id: "DurationLessThanAMinute", title: "Menos de um minuto" },
    { id: "DurationOneToThreeMinutes", title: "Entre 1 e 3 minutos" },
    { id: "DurationMoreThanThreeMinutes", title: "Mais de 3 minutos" },
  ],
});

const getters = {
  getFilters(state) {
    return state.filters;
  },

  getDateType(state) {
    return state.date_types;
  },

  getSortType(state) {
    return state.sortType;
  },

  getSortDirection(state) {
    return state.sortDirection;
  },

  getMediaTypes(state) {
    return state.media_types;
  },

  getCallOptions(state) {
    return state.call_options;
  },

  getAnsweringOptions(state) {
    return state.answering_options;
  },

  getDurationOptions(state) {
    return state.getDurationOptions;
  },

  getBatchMessages(state) {
    return state.batch_messages;
  },

  getKeepFilters(state) {
    return state.keep_filters;
  },

  haveAnyActiveFilters(state) {
    function isBoolean(value) {
      return typeof value === "boolean";
    }

    if (state.filters.start_timestamp) {
      return true;
    }

    if (state.filters.end_timestamp) {
      return true;
    }

    if (state.filters.user_id?.length) {
      return true;
    }

    if (state.filters.product_id?.length) {
      return true;
    }

    if (state.filters.source_type) {
      return true;
    }

    if (state.filters.campaign_id?.length) {
      return true;
    }

    if (state.filters.marketing_campaign_id?.length) {
      return true;
    }

    if (state.filters.media_id?.length) {
      return true;
    }

    if (state.filters.product?.length) {
      return true;
    }

    if (state.filters.closed_type?.length) {
      return true;
    }

    if (state.filters.has_call != null || state.filters.has_call != undefined) {
      return true;
    }

    if (state.filters.has_call_min_duration != null || state.filters.has_call_min_duration != undefined) {
      return true;
    }

    if (state.filters.max_call_attempts) {
      return true;
    }

    if (state.filters.call_start_timestamp) {
      return true;
    }

    if (state.filters.call_end_timestamp) {
      return true;
    }

    if (typeof state.filters.probability === "number") {
      return true;
    }

    if (state.filters.stage?.length) {
      return true;
    }

    if (state.filters.has_generator) {
      return true;
    }

    if (state.filters.state_code) {
      return true;
    }

    if (state.filters.city_name?.length) {
      return true;
    }

    if (isBoolean(state.filters.has_user)) {
      return true;
    }

    if (isBoolean(state.filters.has_city_name)) {
      return true;
    }

    if (isBoolean(state.filters.has_state_code)) {
      return true;
    }

    if (isBoolean(state.filters.has_campaign)) {
      return true;
    }

    if (isBoolean(state.filters.has_product)) {
      return true;
    }

    if (isBoolean(state.filters.is_blacklisted)) {
      return true;
    }

    if (isBoolean(state.filters.has_contract_id)) {
      return true;
    }

    if (state.filters.opportunity_type_id) {
      return true;
    }

    if (state.filters.tags?.length) {
      return true;
    }

    if (isBoolean(state.filters.idle_only)) {
      return true;
    }

    if (state.filters.no_interaction) {
      return true;
    }

    if (state.filters.media_type) {
      return true;
    }

    if (state.filters.last_workspace_id?.length) {
      return true;
    }

    if (isBoolean(state.filters.has_batch_message)) {
      return true;
    }

    if (state.filters.batch_message_id?.length) {
      return true;
    }

    if (isBoolean(state.filters.no_replied_batch_message)) {
      return true;
    }

    return !!state.filters.forms?.length;
  },
};

const actions = {
  resetState({ state }) {
    const initial = initialState();

    const userFromUsers = state.redirectFromUsers;

    if (state.redirectFromUsers) {
      Object.keys(initial).forEach((key) => {
        state[key] = initial[key];
      });

      state.filters.user_id[0] = userFromUsers.id;
      state.filters.user[0] = userFromUsers;
    } else if (!state.keep_filters) {
      Object.keys(initial).forEach((key) => {
        state[key] = initial[key];
      });
    }

    state.redirectFromUsers = null;
  },

  cleanValues({ state }) {
    if (!state.keep_filters) {
      state.filters = {
        no_interaction: false,
        idle_only: null,
        start_timestamp: null,
        end_timestamp: null,
        user: [],
        user_id: [],
        product_id: [],
        stage: [],
        source_type: null,
        campaign_id: [],
        marketing_campaign_id: [],
        media_id: [],
        product: [],
        closed_type: [],
        timestamp_attribute: "updated_at",
        probability: null,
        has_call: null,
        has_call_min_duration: null,
        max_call_attempts: null,
        call_start_timestamp: null,
        call_end_timestamp: null,
        has_generator: null,
        state_code: null,
        city_name: [],
        has_user: null,
        has_city_name: null,
        has_state_code: null,
        has_campaign: null,
        has_product: null,
        has_contract_id: null,
        is_blacklisted: null,
        tags: [],
        opportunity_type_id: null,
        forms: [],
        media_type: null,
        last_workspace_id: [],
        has_batch_message: null,
        batch_message_id: [],
        no_replied_batch_message: undefined,
      };

      state.sortType = [];

      state.sortDirection = [];

      return state.filters;
    }
  },

  setSortType({ state }, sortType) {
    state.sortType = sortType;
  },

  setSortDirection({ state }, sortDirection) {
    state.sortDirection = sortDirection;
  },

  setFilters({ state }, filters) {
    state.filters = filters;
  },

  setIdFromUsers({ state }, userId) {
    state.redirectFromUsers = userId;
  },

  setKeepFilters({ state }, keepFilters) {
    state.keep_filters = keepFilters;
  },

  setBatchMessages({ state }, batchMessages) {
    state.batch_messages = batchMessages;
  },
};

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
};
